import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const HardIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
      <path
        fill="#664500"
        d="M33.3 21a1 1 0 0 0-1.2.4s-2 2.4-6.6 3.7c-1.5.4-3 .6-4.5.6-2 0-3.1-.4-3.1-.4a1 1 0 0 0-1.2 1.5c.2.2 3.6 4.3 8.3 4.3a8 8 0 0 0 2-.2c5.8-1.6 6.9-8.5 7-8.8a1 1 0 0 0-.7-1Zm22 4.4a1 1 0 0 0-1.2-.3s-1.3.5-3.5.5c-1.4 0-2.8-.2-4.1-.5-4.8-1.2-6.8-3.5-6.8-3.6a1 1 0 0 0-1.7.9c0 .2 1.3 7 7 8.5l2 .2c4.7 0 8.1-4.3 8.3-4.5a1 1 0 0 0 0-1.2ZM20 20a2 2 0 0 1-.5-4s7.2-1.9 10.7-8.9A2 2 0 1 1 33.8 9 22 22 0 0 1 20 20Zm32 0A22 22 0 0 1 38.2 8.9 2 2 0 0 1 41.8 7c3.5 7 10.6 9 10.7 9A2 2 0 0 1 52 20ZM36 58c-7.2 0-12 .8-18 2-1.4.2-4 0-4-4 0-8 9.2-18 22-18s22 10 22 18c0 4-2.6 4.2-4 4-6-1.2-10.8-2-18-2Z"
      />
      <path fill="#fff" d="M20 50s6-2 16-2 16 2 16 2-4-8-16-8-16 8-16 8Z" />
    </Icon>
  );
};

export default HardIcon;
